import { TeamLogos } from '@/components/scoreboard/types';
import { Event } from '@/feature/event-details-sbk/types';
import { getTeamColors } from '@/feature/event-details-sbk/utils/get-team-colors';
import { AtLeast } from '@/types/utils';
import { getTeamOrder } from '@/utils/sport-utils';

/** Header-logo bundle derived from an event's team data, display-ordered per sport (getTeamOrder). */
export const getEventTeamLogos = (event: AtLeast<Event, 'home_team' | 'away_team' | 'sport'>) => {
    const colors = getTeamColors(event);
    const icons = { home: event.home_team.logo_url ?? '', away: event.away_team.logo_url ?? '' };
    const [firstSide, secondSide] = getTeamOrder(event.sport.name);
    const teamLogos: TeamLogos = [
        { icon: icons[firstSide], color: colors[firstSide].primary },
        { icon: icons[secondSide], color: colors[secondSide].primary },
    ];
    const shouldShowFallbackLogos: [boolean, boolean] = [
        colors[firstSide].shouldShowFallbackLogo,
        colors[secondSide].shouldShowFallbackLogo,
    ];
    return {
        teamLogos,
        teamFallbackTextColors: [colors[firstSide].secondary, colors[secondSide].secondary],
        shouldShowFallbackLogos,
    };
};
